import { defaultEnvironment } from './environment.default';

export const environment = {
  ...defaultEnvironment,
  dev: true,
  subdomainOrgFilter: {
    ...defaultEnvironment.subdomainOrgFilter,
    enabled: true,
    baseDomain: 'jip-dev.bbv-demo.ch',
  },
};
